export const SET_FETCHING_REPORTS = 'reports/SET_FETCHING_FUNDS';
export const SET_REPORTS = 'reports/SET_REPORTS';